module.exports = __webpack_public_path__ + "static/media/smiles_and_laughters_logo2.7dea60bf.png";